import React from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/react-hooks';
import { Loader } from 'neon-design-system';
import { useFormControl, useFormGroup, useManageTemplateForm } from '../../../utils/form.utils';
import { requiredValidator } from '../../../utils/validator.utils';
import { TagItem } from '../../../shared/types';
import ManageTemplate, { ManageTemplateInstance } from '../../ui/ManageTemplate';
import { ADD_TAG, DELETE_TAG, EDIT_TAG, TAG } from '../../../gql/tags';
import FormTextArea from '../../ui/form/FormTextArea';
import FormTextField from '../../ui/form/FormTextField';
import { makeStyles, createStyles } from '@material-ui/core';
import { baseUrls } from '../../../utils/baseUrls.utils';

const returnListUrl = baseUrls.publisher.tags.list;

const useStyles = makeStyles(theme => createStyles({
	container: {
		display: 'flex',
		justifyContent: 'center',
		width: '100%',
		paddingLeft: theme.spacing(2),
		paddingRight: theme.spacing(2),
		paddingBottom: theme.spacing(6)
	},
	main: {
		flex: 1,
		flexDirection: 'column',
		maxWidth: 1200
	}
}));


const TagAddEdit = (): JSX.Element => {
	const { _id } = useParams();
	const classes = useStyles();
	const form = useFormGroup({
		name: useFormControl<string>('', [requiredValidator]),
		description: useFormControl<string>('', [requiredValidator])
	});

	const { loading, data } = useQuery<{ document: TagItem }>(TAG, {
		skip: !_id,
		fetchPolicy: 'network-only',
		variables: { id: _id },
		onCompleted: ({ document }) => {
			form.name.setInitialValue(document.name);
			form.description.setInitialValue(document.description);
		}
	});

	const { isNew, formMessage, formBusy, onSubmit, onCancel, onDelete, onAlertBoxClose } = useManageTemplateForm(
		ManageTemplateInstance.Tag,
		form,
		data?.document,
		ADD_TAG,
		EDIT_TAG,
		DELETE_TAG,
		returnListUrl
	);

	if (loading) return <Loader />;

	return (
		<div className={classes.container}>
			<div className={classes.main}>
				<ManageTemplate
					dialogMessage={<>
						You are about to delete the tag
						<strong> {form.name.value}</strong>.
						This action cannot be undone, so you must be sure and confirm.
					</>}
					onDelete={() => onDelete(form.name.value)}
					pathArea={'Tags'}
					returnUrl={returnListUrl}
					templateInstance={ManageTemplateInstance.Tag}
					isNew={isNew}
					formMessage={formMessage}
					formBusy={formBusy}
					onCancel={onCancel}
					onSubmit={ev => onSubmit(ev, { ...form.value, version: !isNew ? data?.document?.version : undefined })}
					onAlertBoxClose={onAlertBoxClose}
				>
					<FormTextField
						id="tag-name-input"
						label="Name"
						field={form.name}
						charsLimit={50} />
					<FormTextArea
						id={'tag-description-textarea'}
						field={form.description}
						charsLimit={500} />
				</ManageTemplate>
			</div>
		</div>

	);
};

export default TagAddEdit;
